import React from 'react';

const AuthModal = ({ isOpen, onClose, onLogin }) => {
    if (!isOpen) return null;

    return (
        <div 
            className="modal show d-block position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" 
            tabIndex="-1" 
            style={{ 
                backgroundColor: 'rgba(0,0,0,0.5)', 
                zIndex: 1050 
            }}
        >
            <div className="modal-dialog" style={{ maxWidth: '85%', width: '85%' }}>
                <div className="modal-content bg-dark text-white">
                    <div className="modal-header border-0">
                        <button 
                            type="button" 
                            className="btn-close btn-close-white" 
                            onClick={onClose}
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body text-center pb-4">
                        <h5 className="mb-3">Connect your Spotify account</h5>
                        <p className="text-muted mb-4">
                            Get personalized music recommendations
                        </p>
                        <div className="d-flex justify-content-center gap-3">
                            <button 
                                onClick={onLogin}
                                className="btn btn-light px-4 d-flex align-items-center gap-2 mx-auto"
                            >
                                <i className="bi bi-spotify"></i>
                                Connect Spotify
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthModal;